import { ERROR, LOADING, READY, UNINITIALIZED, useVisualState } from '../../../hooks/useVisualState'
import React, { useCallback, useEffect } from 'react'

import GenericErrorModal from '../../../modules/GenericErrorModal/GenericErrorModal'
import TeamCard from '../../../components/Cards/TeamCard/TeamCard'
import { oldGet } from '../../../helpers/requestOld'
import t from '../../../helpers/i18n'
import { withRouter } from 'react-router-dom'

const OldTeamsView = ({ history }) => {
  const [[teamsState, teams], setTeams] = useVisualState()

  const handleOpenProfile = useCallback((team_id) => history.push("/cm/teams/" + team_id), [history])

  useEffect(() => {
    setTeams(LOADING)
    oldGet('/delegate/teams').then(response => {
      setTeams(READY, response)
    }).catch(error => {
      setTeams(ERROR, error)
    })
  }, [setTeams])

  return (
    <div className="main-content">
      <div className="-page-header">
        <div className="-left label-extra-large-semibold">{t('titles.Teams')}</div>
      </div>

      <div className="-content">
        {teamsState === READY && teams.map(team => (
          <TeamCard
            key={team.team_id}
            name={team.name}
            logo={team.logo}
            tags={[team.short_name]}
            players={team.players}
            staff={team.staff}
            delegates={team.delegates}
            categoryName={team.category_name}
            categoryLogo={team.category_logo}
            organizationName={team.organization_name}
            onClick={() => handleOpenProfile(team.team_id)}
          />
        ))}
      </div>

      {teamsState === ERROR && <GenericErrorModal error={teams} i18nPrefix="OldTeamsView" onCloseRequested={() => setTeams(UNINITIALIZED)} />}
    </div>
  )
}

export default withRouter(OldTeamsView)
